import ink from "../wordmark-ink.png";
import reverse from "../wordmark-reverse.png";

/**
 * The same mark as the marketing site, so the product does not look like a
 * different company once someone signs in. Both variants ship; CSS picks one
 * by theme, which keeps it correct without JavaScript.
 */
export function Wordmark({ height = 26 }: { height?: number }) {
  return (
    <span className="wordmark" style={{ height }}>
      <img className="wm-ink" src={ink} alt="Hauzisha Systems" />
      <img className="wm-rev" src={reverse} alt="" aria-hidden="true" />
    </span>
  );
}
